// Oculta SOLO las filas con títulos concatenados por la antigua importación.
// Nunca borra escenarios ni cambia IDs: eventos, historial y créditos siguen referenciando sus registros.
const normalizedTitle = (text) => String(text || "").normalize("NFD")
  .replace(/[\u0300-\u036f]/g, "").toLowerCase().replace(/[^a-z0-9]+/g, "");
const keyPart = (value) => {
  const raw = String(value || "").trim().toLowerCase();
  return /^\d+$/.test(raw) ? String(Number(raw)) : raw;
};

function isConcatenatedName(bad, good) {
  const longer = normalizedTitle(bad);
  const shorter = normalizedTitle(good);
  if (!shorter || longer.length <= shorter.length || !longer.endsWith(shorter)) return false;
  const prefix = longer.slice(0, -shorter.length);
  // Explicitly require repetition of the full title, with or without its leading article.
  // Avoid collapsing "Intro: Title", "Part 1, Title", or distinct subtier variants.
  const noArticle = shorter.replace(/^(?:the|an|a)/, "");
  return prefix === shorter || (noArticle.length > 5 && prefix === noArticle);
}

export function catalogForTracker(scenarios) {
  const groups = new Map();
  for (const item of scenarios) {
    const key = [item.game, item.type || "escenario",
      keyPart(item.season), keyPart(item.number)].join("|");
    if (!groups.has(key)) groups.set(key, []);
    groups.get(key).push(item);
  }
  return scenarios.filter((item) => {
    const key = [item.game, item.type || "escenario",
      keyPart(item.season), keyPart(item.number)].join("|");
    return !groups.get(key).some((alternative) =>
      alternative.id !== item.id && isConcatenatedName(item.name, alternative.name));
  });
}
